import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import { frontendTechStack } from "../../config/TechStatckData/frontendTechStack";
import TechStack from "../Skill/TechStack";

// const items = [
//   <img src="path-to-img" onDragStart={(e)=>e.preventDefault()} role="presentation" />,
//   <img src="path-to-img" onDragStart={(e)=>e.preventDefault()} role="presentation" />,
//   <img src="path-to-img" onDragStart={(e)=>e.preventDefault()} role="presentation" />,
// ];

const Carousel = ({data,direction}) => {
  let items = data.map((item) => {
    return (
      <div className="flex justify-center items-center">
        <TechStack key={item} img={item.img} name={item.name} />
      </div>
    );
  });

  const responsive = {
    0: {
      items: 2,
    },
    512: {
      items: 4,
    },
    720: {
      items: 9,
    },
    2000: {
      items: 12,
    },
  };
  return (
    <div className="flex justify-center">
      <AliceCarousel
        mouseTracking
        controlsStrategy={"default"}
        items={items}
        infinite
        autoPlayInterval={1000}
        animationDuration={1500}
        autoPlayDirection={direction}
        disableDotsControls
        disableButtonsControls
        responsive={responsive}
        autoPlay
      />
    </div>
  );
};

export default Carousel;
